import styles from "styles.module.css";
import SalesNoteCard from "./SalesNoteCard";
import AccountingSettlementCard from "./AccountingSettelmentCard";
import {
	useHomePageAccessStore,
	useUserOrganizationsStore,
	useUserStore,
} from "store";
import LandingNoteCard from "./LandingNoteCard";
import { OrganizationType } from "interface/user";
import InvoiceCard from "./InvoiceCard";
import PurchaseOverviewCard from "./PurchaseOverviewCard";
import YearlyRevenueCard from "./YearlyRevenueCard";

import ReleasePackageCard from "./ReleasePackageCard";
import VesselQuota from "./VesselQuota";
import MonthlyTurnoverBySpeciesCard from "./MonthlyTurnoverBySpeciesCard";
import MonthlyValueBySpeciesCard from "./MonthlyValueBySpeciesCard";
import { useState, useRef, useEffect } from "react";
import BuyerCardHeader from "./BuyerCardHeader";

const HomePageItems = () => {
	const { user, isAdmin } = useUserStore();
	const { defaultOrg } = useUserOrganizationsStore();
	const [marginBottom, setMarginBottom] = useState<number>(30);
	const [isMobileView, setIsMobileView] = useState<boolean>(
		window.innerWidth < 1600,
	);
	const [isTabletView, setIsTabletView] = useState<boolean>(
		window.innerWidth < 1600,
	);

	const { homePageAccess, loadHomePageAccess } = useHomePageAccessStore();

	let year = new Date().getFullYear();

	useEffect(() => {
		const handleResize = () => {
			setIsMobileView(window.innerWidth < 1600);
			setIsTabletView(window.innerWidth < 1600);
		};

		handleResize();
		window.addEventListener("resize", handleResize);
		loadHomePageAccess();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	useEffect(() => {
		if (!defaultOrg) {
			//
			return;
		}

		if (defaultOrg.type === OrganizationType.Terminal) {
			setMarginBottom(0);
		} else if (defaultOrg.type === OrganizationType.Buyer) {
			setMarginBottom(44);
		} else if (defaultOrg.type === OrganizationType.Vessel) {
			setMarginBottom(0);
		}
	}, [defaultOrg, year]);

	if (!user) return <div></div>;

	return (
		<div
			style={{
				display: "flex",
				flexDirection: isMobileView ? "column" : "row",
				gap: isMobileView ? 16 : 30,
				height: isMobileView ? "auto" : "100%",
				width: "100%",
			}}
		>
			<div style={{ width: "100%" }}>
				{isAdmin && !defaultOrg && (
					<>
						<div className="" style={{ marginBottom: "30px" }}>
							<BuyerCardHeader
								isMobile={isMobileView}
								year={year}
								organization={defaultOrg}
							/>
						</div>
						<div
							style={{
								display: "flex",
								flexDirection: isMobileView ? "column" : "row",
								gap: "30px",
								marginBottom: "30px",
							}}
						>
							<div className="border-radius" style={{ flex: 1 }}>
								<MonthlyTurnoverBySpeciesCard isMobileView={isMobileView} />
							</div>
							<div className="border-radius" style={{ flex: 1 }}>
								<MonthlyValueBySpeciesCard isMobileView={isMobileView} />
							</div>
						</div>
					</>
				)}
				{defaultOrg && (
					<>
						<div
							style={{
								display: "flex",
								flexDirection:
									defaultOrg.type === OrganizationType.Buyer && isTabletView
										? "column"
										: isMobileView
											? "column"
											: "row",
								justifyContent: "space-between",
								marginBottom: `${marginBottom}px`,
								width: "100%",
								gap: "30px",
							}}
						>
							{defaultOrg.type === OrganizationType.Buyer && (
								<div style={{ flex: 1 }} className="border-radius">
									<BuyerCardHeader
										isMobile={isMobileView}
										year={year}
										organization={defaultOrg}
									/>
								</div>
							)}
						</div>

						<div
							style={{
								display: "flex",
								flexDirection: "column",
								gap: "30px",
								paddingBottom: "50px",
							}}
						>
							{defaultOrg.type === OrganizationType.Buyer && (
								<>
									<div>
										<PurchaseOverviewCard
											buyerLedgerAccountNumber={defaultOrg.ledgerAccountNumber}
											isMobileView={isMobileView}
										/>
									</div>
									{homePageAccess?.salesNote?.read && (
										<div className="border-radius">
											<SalesNoteCard isMobileView={isMobileView} />
										</div>
									)}
									<div>
										<InvoiceCard
											isMobileView={isMobileView}
											buyerLedgerAccountNumber={defaultOrg.ledgerAccountNumber}
										/>
									</div>
								</>
							)}
							{defaultOrg.type === OrganizationType.Vessel && (
								<>
									{homePageAccess?.home?.special1 && (
										<div>
											<VesselQuota isMobileView={isMobileView} />
										</div>
									)}
									{homePageAccess?.landingNote?.read && (
										<div className="border-radius">
											<LandingNoteCard isMobileView={isMobileView} />
										</div>
									)}
									{homePageAccess?.salesNote?.read && (
										<div className="border-radius">
											<SalesNoteCard isMobileView={isMobileView} />
										</div>
									)}
									<div className="border-radius">
										<AccountingSettlementCard isMobileView={isMobileView} />
									</div>
									<div className="border-radius">
										<YearlyRevenueCard isMobileView={isMobileView} />
									</div>{" "}
								</>
							)}
							{defaultOrg.type === OrganizationType.Terminal && (
								<>
									{homePageAccess?.landingNote?.read && (
										<div className="border-radius">
											<LandingNoteCard isMobileView={isMobileView} />
										</div>
									)}
									<div className="border-radius">
										<ReleasePackageCard isMobileView={isMobileView} />
									</div>
								</>
							)}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default HomePageItems;
